export enum TextInputType {
  text = "text",
  number = "number",
  password = "password",
}
